import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, msg } from './hubApi';
import { loadPayPal } from './paypal';

const money = n => 'A$' + Number(n).toFixed(2);
const until = iso => new Date(iso).toLocaleString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', timeZone: 'Australia/Sydney' });

// Buy access to a paid leader: today's tips (one-off), a week or a month (one-off or recurring).
export default function BuyBox({ handle, market, user, onBought }) {
  const [sel, setSel] = useState(market.offers[0]?.kind || 'DAY');
  const [recurring, setRecurring] = useState(true);
  const [note, setNote] = useState('');
  const ref = useRef(null);
  const offer = market.offers.find(o => o.kind === sel);
  const isSub = offer?.kind !== 'DAY' && offer?.recurring && recurring;

  useEffect(() => {
    if (!user || !offer || !ref.current) return;
    let cancelled = false, btn = null;
    ref.current.innerHTML = '';
    setNote('');
    loadPayPal(isSub ? 'sub' : 'order').then(pp => {
      if (cancelled) return;
      let passId = null;
      const common = { style: { layout: 'vertical', shape: 'rect', label: isSub ? 'subscribe' : 'pay', height: 42 },
        onError: () => setNote('PayPal had a problem. Nothing was charged. Please try again.'), onCancel: () => setNote('Payment cancelled.') };
      btn = pp.Buttons(isSub ? {
        ...common,
        createSubscription: async (_d, actions) => {
          const r = await api('/billing/subscriptions/start', { method: 'POST', body: { handle, kind: sel } });
          passId = r.passId;
          return actions.subscription.create({ plan_id: r.planId, custom_id: r.passId });
        },
        onApprove: async d => {
          try { await api('/billing/subscriptions/confirm', { method: 'POST', body: { passId, subscriptionId: d.subscriptionID } }); setNote('Done — you have access.'); onBought(); }
          catch (e) { setNote(msg(e)); }
        },
      } : {
        ...common,
        createOrder: async () => (await api('/billing/orders/create', { method: 'POST', body: { handle, kind: sel } })).orderId,
        onApprove: async d => {
          try { await api('/billing/orders/capture', { method: 'POST', body: { orderId: d.orderID } }); setNote('Done — you have access.'); onBought(); }
          catch (e) { setNote(msg(e)); }
        },
      });
      btn.render(ref.current);
    }).catch(e => setNote(msg(e)));
    return () => { cancelled = true; try { btn?.close?.(); } catch {} };
  }, [sel, isSub, user?._id]);

  if (market.access && market.pass) return (
    <section className="card">
      <h2>You have access</h2>
      <p>{market.pass.label}{market.pass.recurring ? (market.pass.status === 'ACTIVE' ? ' · renews automatically' : ' · cancelled, no further charges') : ''} · until {until(market.pass.endsAt)}.</p>
      <p className="fine">Their picks go into your account as units × your unit size. Manage the mimic under <Link to="/hub/sources">Sources &amp; limits</Link> and purchases under <Link to="/hub/account">Account</Link>.</p>
    </section>
  );
  return (
    <section className="card">
      <h2>Get this leader’s tips</h2>
      <p className="fine">Unlocks their picks before the jump and lets you mirror them into your own Betfair account in units, under your own limits.</p>
      <div className="offers">
        {market.offers.map(o => (
          <button key={o.kind} className={'offer ' + (o.kind === sel ? 'on' : '')} onClick={() => setSel(o.kind)}>
            <b>{money(o.price)}</b><span>{o.label}</span>
          </button>))}
      </div>
      {offer && offer.kind !== 'DAY' && offer.recurring && (
        <label className="inline"><input type="checkbox" checked={recurring} onChange={e => setRecurring(e.target.checked)} /> Renew automatically every {offer.kind === 'WEEK' ? 'week' : 'month'} (cancel any time)</label>)}
      {!user ? <p><Link to="/">Log in or create a free account</Link> to buy.</p> : <div ref={ref} className="ppbox" />}
      {note && <p className="note">{note}</p>}
      <p className="fine">Paid to Betbuilder Pty Ltd via PayPal. Past results don’t guarantee future results. 18+ only.</p>
    </section>
  );
}
